<template>
  <v-autocomplete
    id="temas-select"
    v-model="filter.membro"
    item-text="nome"
    item-value="membroId"
    :items="values"
    label="Membros"
    placeholder="Membro"
    v-on:change="$emit('onChange')"
    :disabled="disabled"
    :clearable="true"
    :return-object="true"
  >
    <template slot="no-data"> Nenhum Membro retornado </template>
  </v-autocomplete>
</template>

<script>
import { membrosApi } from "@/apis";
import { mapActions } from "vuex";

export default {
  name: "AppEixoCombobox",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    defaultValue: {
      type: String | Number,
    },
    filter: {
      type: Object,
      default: () => {
        ({ membro: {} });
      },
    },
    municipioId: {
      type: String,
      default: () => {
        "0";
      },
    },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    this.load();
  },
  watch: {
    defaultValue(value) {
      if (value && this.values.length > 0) {
        this.filter.membro = this.values.filter(
          (item) => item.membroId === value
        )[0];
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    load() {
      this.setLoading(true);
      membrosApi
        .getMembroByMunicipio(this.municipioId)
        .then((resp) => {
          this.setLoading(false);
          this.values = resp.data;

          if (this.defaultValue) {
            this.filter.membro = this.values.filter(
              (item) => item.membroId === this.defaultValue
            )[0];
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          console.log("Erro ao obter membros: ", resp);
          this.$notification.error("Erro ao obter Membros");
        });
    },
  },
  data() {
    return {
      values: [],
    };
  },
};
</script>
